import {faTableColumns} from "@fortawesome/free-solid-svg-icons";

export default faTableColumns;
